import dayjs from "dayjs";

export default {
  methods: {
    formatMessageDate(message) {
      let date = message.updatedAt || message.createdAt;
      return dayjs().date() === dayjs(date).date()
        ? dayjs(date).format("HH:mm")
        : dayjs(date).format("ddd D MMM HH:mm");
    }
  }
};
